import React from 'react';
import './style.css';

export default () => <div className="horizontal-bar" />;
